module.exports = __webpack_public_path__ + "img/hongbao.1b9985ea.png";